
import { Autoplay, Navigation } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';

const title = "Field of Study";

const courseList = [
    {
        imgUrl: 'assets/images/course/law.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        courseName: 'Law',
        coursePrice: '$199.00',
        courseTitle: 'Gain in-depth knowledge of legal systems, policies, and ethics to build a strong career in the legal field.',
        user: '200',
        commentCount: '23',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/engineer.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        courseName: 'Engineering',
        coursePrice: 'Free',
        courseTitle: 'Develop problem-solving skills and technical expertise to innovate and shape the future of technology.',
        user: '200',
        commentCount: '23',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/medi.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        courseName: 'Medical & Healthcare',
        coursePrice: '$199.00',
        courseTitle: 'Train to become a healthcare professional dedicated to saving lives and improving well-being.',
        user: '200',
        commentCount: '23',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/edu.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        courseName: 'Education',
        coursePrice: '$199.00',
        courseTitle: 'Learn effective teaching methods and leadership skills to inspire future generations.',
        user: '200',
        commentCount: '23',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/film.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        courseName: 'Film & Arts',
        coursePrice: '$199.00',
        courseTitle: ' Unleash your creativity in filmmaking, visual arts, and performing arts to express powerful stories.',
        user: '200',
        commentCount: '23',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/sport.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        courseName: 'Sports',
        coursePrice: '$199.00',
        courseTitle: ' Enhance your athletic skills, sports management knowledge, and performance training for a successful career in sports.',
        user: '200',
        commentCount: '23',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/management.jpg',
        imgAlt: 'course rajibraj91 rajibraj',
        courseName: 'Business & Management',
        coursePrice: '$199.00',
        courseTitle: ' Master leadership, strategy, and entrepreneurship to excel in the corporate world.',
        user: '200',
        commentCount: '23',
        btnText: 'Read More',
    },
]


const CourseThree = () => {
    return (
        <div className="course-section style-2 padding-tb">
            <div className="container">
                <div className="section-header flex ">
                    <h2 className="title">{title}</h2>
                    <div className="course-navigations">
                        <div className="course-navi course-navi-next"><i className="icofont-double-left"></i></div>
                        <div className="course-navi course-navi-prev"><i className="icofont-double-right"></i></div>
                    </div>
                </div>
                <div className="section-wrapper ">
                    <div className="course-slider p-2">
                        <div className="swiper-wrapper">
                            <Swiper
                                spaceBetween={5}
                                slidesPerView={5}
                                loop={'true'}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                                }}
                                navigation={{
                                    prevEl: '.course-navi-prev',
                                    nextEl: '.course-navi-next',
                                }}
                                modules={[Autoplay, Navigation]}
                                breakpoints={{
                                    0: {
                                        width: 0,
                                        slidesPerView: 1,
                                    },
                                    768: {
                                        width: 768,
                                        slidesPerView: 2,
                                    },
                                    1200: {
                                        width: 1200,
                                        slidesPerView: 2.85,
                                    },
                                }}
                            >
                                {courseList.map((val, i) => (
                                    <SwiperSlide key={i}>
                                       <div className="c w-[250px]  rounded-lg overflow-hidden">
    <div className="cour text-center p-3">
        <div className="course- bg--400 w-[200px] h-[150px] mx-auto flex justify-center items-center">
            <img className="w-full h-full object-cover rounded-md" src={val.imgUrl} alt={val.imgAlt} />
        </div>
        <ul className="course-info lab-ul mt-3 text-sm text-gray-700">
            <li><span className="course-name font-medium">{val.courseName}</span></li>
            <li>
                <span className="ratting flex justify-center gap-1 text-yellow-400">
                    <i className="icofont-ui-rate-blank"></i>
                    <i className="icofont-ui-rate-blank"></i>
                    <i className="icofont-ui-rate-blank"></i>
                    <i className="icofont-ui-rate-blank"></i>
                    <i className="icofont-ui-rate-blank"></i>
                </span>
            </li>
        </ul>
    </div>
</div>

                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default CourseThree;